const positions = {
    BOTTOM_LEFT: { vertical: 'bottom', horizontal: 'left' },
    BOTTOM: { vertical: 'bottom', horizontal: 'center' },
    BOTTOM_RIGHT: { vertical: 'bottom', horizontal: 'right' },
    TOP_LEFT: { vertical: 'top', horizontal: 'left' },
    TOP: { vertical: 'top', horizontal: 'center' },
    TOP_RIGHT: { vertical: 'top', horizontal: 'right' }
};

export default positions;


// WEBPACK FOOTER //
// ./src/constants/anchorOriginPositions.js